import { AboutSubscriptionsPage } from '@/pages/about-subscriptions';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/about-subscriptions')({
	component: AboutSubscriptionsPage,
});
